import { Grid, MenuItem } from "@mui/material";
import { Formik } from "formik";
import FormikActions from "../../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../../commons/formik/FormikAutocomplete";
import FormikCheckbox from "../../../../commons/formik/FormikCheckbox";
import FormikSelect from "../../../../commons/formik/FormikSelect";
import { StyledNuevaDenuncia } from "../../../../styled/Siniestros";
import { accidenteTrabajoFormValidation, validateRequiredFields, } from "../validation/formValidation";

const AccidenteTrabajoForm = ({
  handleSubmit,
  model,
  fields,
  listaFormaAccidente,
  listaAgenteMaterial,
  listaSubTipoAccidente,
}) => {

  return (
    <Formik
      initialValues={model}
      onSubmit={handleSubmit}
      validationSchema={accidenteTrabajoFormValidation}
      validate={(values) => validateRequiredFields(values, fields)}
    >
      <StyledNuevaDenuncia.FormContainer>
        <StyledNuevaDenuncia.GridContainer container spacing={9}>
          <Grid item xs={6}>
            <FormikSelect
              fullWidth
              name="subTipoAccidente"
              label={`Subtipo accidente ${fields.subTipoSiniestro?.obligatorio ? "*" : ""
                }`}
              variant="standard"
            >
              {listaSubTipoAccidente.map(({ id, nombre }) => {
                return (
                  <MenuItem value={id} key={id}>
                    {nombre}
                  </MenuItem>
                );
              })}
            </FormikSelect>
          </Grid>
          <Grid item xs={3}>
            <FormikCheckbox
              id="ocurrenciaViaPublica"
              name="ocurrenciaViaPublica"
              label={`Ocurrencia en la vía pública ${fields.ocurrenciaViaPublica?.obligatorio ? "*" : ""
                }`}
            />
          </Grid>
          <Grid item xs={3}>
            <FormikCheckbox
              id="teletrabajo"
              name="teletrabajo"
              label={`Teletrabajo ${fields.teletrabajo?.obligatorio ? "*" : ""
                }`}
            />
          </Grid>
          <Grid item xs={6}>
            <FormikAutocomplete
              fullWidth
              name="agenteCausante"
              label={`Agente causante ${fields.agenteCausante?.obligatorio ? "*" : ""
                }`}
              variant="standard"
              options={listaAgenteMaterial}
              renderOption={(option) => option.nombre}
              filterOptions={(option) => option.nombre}
            />
          </Grid>
          <Grid item xs={3}>
            <FormikAutocomplete
              fullWidth
              name="formaAccidente"
              label={`Forma accidente ${fields.formaAccidente?.obligatorio ? "*" : ""
                }`}
              variant="standard"
              options={listaFormaAccidente}
              renderOption={(option) => option.nombre}
              filterOptions={(option) => option.nombre}
            />
          </Grid>
        </StyledNuevaDenuncia.GridContainer>
        <StyledNuevaDenuncia.ButtonContainer>
          <FormikActions submit="Siguiente" />
        </StyledNuevaDenuncia.ButtonContainer>
      </StyledNuevaDenuncia.FormContainer>
    </Formik>
  );
};

export default AccidenteTrabajoForm;
